import React from 'react';
import TopBar from './TopBar';
import MainLinks from './MainLinks';
import { Link } from './types/Navigation.types';

type DesktopNavigationProps = {
  brandLink: string;
  topLevelLinks: Link[];
  mainLinks: Link[];
  pageTitle: string;
  secondLanguageUrlPrefix?: string;
  isSecondLanguageOnUrl?: boolean;
  languageLink: Link;
  signInUrl: string;
  signInLabel: string;
};

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({
  topLevelLinks,
  languageLink,
  pageTitle,
  isSecondLanguageOnUrl,
  secondLanguageUrlPrefix,
  brandLink,
  mainLinks,
  signInLabel,
  signInUrl,
}) => {
  return (
    <>
      <TopBar
        topLevelLinks={topLevelLinks}
        languageLink={languageLink}
        pageTitle={pageTitle}
        isSecondLanguageOnUrl={isSecondLanguageOnUrl}
        secondLanguageUrlPrefix={secondLanguageUrlPrefix}
      />
      <MainLinks
        brandLink={brandLink}
        mainLinks={mainLinks}
        pageTitle={pageTitle}
        isSecondLanguageOnUrl={isSecondLanguageOnUrl}
        secondLanguageUrlPrefix={secondLanguageUrlPrefix}
        signInLabel={signInLabel}
        signInUrl={signInUrl}
      />
    </>
  );
};

export default DesktopNavigation;
